.stack {
  display: flex;
  gap: var(--stack-gap, var(--sp-4));
}

.col { flex-direction: column; }
.row { flex-direction: row; }
.wrap { flex-wrap: wrap; }
